import { useEffect, useState } from "react";
import styles from "./list.module.css";
import dayjs from "dayjs";
import { Button, Snackbar, Alert, Dialog, DialogTitle, IconButton, DialogContent, Select, FormControl, InputLabel, MenuItem, OutlinedInput, Box, Chip, Checkbox, ListItemText } from "@mui/material";
import { Home } from "react-feather";
import { Close } from "@mui/icons-material";
import axios from "axios";
import Loader from "../../../components/Loader";
import { TableLoader } from "../../../components/ContentLoader";
import { authData, withAdminAuth } from "../../../components/GetAuth";
import AddDriverForm from "../../driver/AddDriverForm";
import Step1 from "./steps/Step1";
import Step2 from "./steps/Step2";
import Step3 from "./steps/Step3";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
}

const BookingList = () => {
  const auth = authData();
  const API_TOKEN = auth?.api_token;
  const [loading, setLoading] = useState(false);
  const [contentLoading, setContentLoading] = useState(true);
  const [allData, setAllData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [filterVars, setFilterVars] = useState({ searchKey: "", date: null });
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarType, setSnackbarType] = useState("success");
  const [formOpen, setFormOpen] = useState(false);
  const [driverFormOpen, setDriverFormOpen] = useState(false);
  const [driverList, setDriverList] = useState([]);
  const [selectedDriverList, setSelectedDriverList] = useState([]);
  const [selected, setSelected] = useState([]);
  const [currentStep, setCurrentStep] = useState(1);
  const [routes, setRoutes] = useState([]);

  useEffect(() => {
    const fetchBookings = () => {
      setContentLoading(true);
      axios.get(process.env.REACT_APP_API_URL + "v1/assign-bookings", {
        headers: {
          Authorization: `Bearer ${API_TOKEN}`,
        }
      }).then((response) => {
        setContentLoading(false);
        setAllData(response.data.data);
      }).catch((error) => {
        setContentLoading(false);
      });
    };

    fetchBookings();
  }, [API_TOKEN]);

  useEffect(() => {
    let filterredTempData = allData;

    if (filterVars?.searchKey !== "") {
      let inputVal = filterVars?.searchKey;
      inputVal = inputVal.toLowerCase();
      filterredTempData = filterredTempData.filter((item) => {
        return (item.booking_id.toLowerCase().includes(inputVal) || item.post_code.toLowerCase().includes(inputVal) || item.customer_name.toLowerCase().includes(inputVal) || item.pickup_details?.address.toLowerCase().includes(inputVal) || item.pickup_details?.phone.toLowerCase().includes(inputVal));
      });
    }

    if (filterVars?.date) {
      filterredTempData = filterredTempData.filter((i) => dayjs(i?.pickup_date).isBetween(dayjs(filterVars?.date[0]).format("YYYY-MM-DD"), dayjs(filterVars?.date[1]).format("YYYY-MM-DD"), "day", "[]"));
    }

    setFilteredData(filterredTempData);
  }, [allData, filterVars]);

  const selectRowEvent = (id) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
    }
    setSelected(newSelected);
  }

  useEffect(() => {
    axios.get(process.env.REACT_APP_API_URL + "v1/p-driver-dd-list", {
      headers: {
        Authorization: `Bearer ${API_TOKEN}`,
      }
    }).then((response) => {
      if (response.data.status === "SUCCESS") {
        setDriverList(response.data.data);
      }
    });
  }, [API_TOKEN]);

  const getOptimizeRoute = () => {
    setLoading(true);

    let bookingListTemp = allData?.filter(i => selected?.indexOf(i?.id) > -1)?.map(i => {
      return { id: i?.id, booking_id: i?.booking_id, customer_name: i?.customer_name, address: i?.pickup_details?.address, lat: i?.pickup_details?.latitude, lng: i?.pickup_details?.longitude };
    });
    let driverListTemp = driverList?.filter(i => selectedDriverList?.indexOf(i?.id) > -1)?.map(i => {
      return { id: i?.id, name: i?.name, address: i?.address, lat: i?.latitude, lng: i?.longitude };
    });

    setLoading(true);

    axios.post(process.env.REACT_APP_API_URL + 'v1/optimize-route', { drivers: driverListTemp, pickups: bookingListTemp }, {
      headers: {
        Authorization: `Bearer ${auth?.api_token}`,
      }
    }).then(response => {
      setLoading(false);
      setRoutes(response.data.data);
      setCurrentStep(2);
    }).catch(error => {
      setLoading(false);
    });
  }

  return (<>
    <Loader open={loading} setOpen={setLoading.bind(this)} />
    <div className={`${styles.MainDiv}`}>
      <div className={`${styles.MainCard}`}>
        {contentLoading && <TableLoader />}

        {!contentLoading && (<div className={`${styles.PageTitleWrap}`}>
          <p className={`${styles.PageTitle}`}>Assign To Driver</p>
          <nav aria-label="breadcrumb">
            <ol className={`${styles.breadcrumb}`}>
              <li className={`${styles.breadcrumbItem}`}><span><Home /></span>Booking</li>
              <li className={`${styles.breadcrumbItem} ${styles.active}`}>Assign To Driver</li>
            </ol>
          </nav>
        </div>)}

        {!contentLoading && (<>
          {currentStep === 1 && <Step1 selected={selected} filteredData={filteredData} filterVars={filterVars} driverList={driverList} selectedDriverList={selectedDriverList} setFilterVars={setFilterVars.bind(this)} setFormOpen={setFormOpen.bind(this)} setSelectedDriverList={setSelectedDriverList.bind(this)} getOptimizeRoute={getOptimizeRoute.bind(this)} selectRowEvent={selectRowEvent.bind(this)} setSelected={setSelected.bind(this)} />}

          {currentStep === 2 && <Step2 routes={routes} setCurrentStep={setCurrentStep.bind(this)} />}

          {currentStep === 3 && <Step3 routes={routes} setCurrentStep={setCurrentStep.bind(this)} setLoading={setLoading.bind(this)} setSnackbarType={setSnackbarType.bind(this)} setSnackbarOpen={setSnackbarOpen.bind(this)} setSnackbarMessage={setSnackbarMessage.bind(this)} setRoutes={setRoutes.bind(this)} />}
        </>)}
      </div>
    </div>

    <Dialog
      open={formOpen}
      onClose={(e) => setFormOpen(false)}
      fullWidth
      maxWidth="xs"
      className="NewPopUp"
    >
      <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">Assign Booking Details To Driver</DialogTitle>
      <IconButton aria-label="close" onClick={(e) => setFormOpen(false)} sx={{ position: "absolute", right: 8, top: 8 }}><Close /></IconButton>
      <DialogContent>
        <div className={`${styles.FormMainRow}`}>
          <div className={`${styles.FormGroupFull} FormGroup`}>
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">Select Driver</InputLabel>
              <Select
                label="Select Driver"
                multiple
                value={selectedDriverList}
                onChange={(e) => {
                  const value = e.target.value;
                  setSelectedDriverList(typeof value === 'string' ? value.split(',').map(Number) : value);
                }}
                input={<OutlinedInput id="select-multiple-chip" label="People" />}
                renderValue={(selected) => (
                  <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                    {selected.map((id) => {
                      const person = driverList.find((p) => p.id === id);
                      return <Chip key={id} label={person?.name || id} />;
                    })}
                  </Box>
                )}
                MenuProps={MenuProps}
              >
                {driverList?.map((i) => {
                  return (<MenuItem key={i?.id} value={i?.id}>
                    <Checkbox checked={selectedDriverList.includes(i?.id)} />
                    <ListItemText primary={i?.name} />
                  </MenuItem>);
                })}
              </Select>
            </FormControl>
          </div>
          <div className={`FormButtonArea`}>
            <Button className={`SubmitBU`} onClick={(e) => setFormOpen(false)}>Assign</Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>

    <Dialog
      open={driverFormOpen}
      onClose={(e) => setFormOpen(false)}
      fullWidth
      maxWidth="xs"
      className="NewPopUp"
    >
      <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">Add Driver</DialogTitle>
      <IconButton aria-label="close" onClick={(e) => setDriverFormOpen(false)} sx={{ position: "absolute", right: 8, top: 8 }}><Close /></IconButton>
      <DialogContent>
        <AddDriverForm setFormOpen={setDriverFormOpen.bind(this)} setAllData={null} setSnackbarOpen={setSnackbarOpen.bind(this)} setSnackbarMessage={setSnackbarMessage.bind(this)} setSnackbarType={setSnackbarType.bind(this)} setLoading={setLoading.bind(this)} editData={null} />
      </DialogContent>
    </Dialog>

    <Snackbar
      open={snackbarOpen}
      autoHideDuration={6000}
      onClose={(e) => setSnackbarOpen(false)}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
    >
      <Alert
        onClose={(e) => setSnackbarOpen(false)}
        severity={snackbarType}
        variant="filled"
        sx={{ width: "100%" }}
      >
        {snackbarMessage}
      </Alert>
    </Snackbar>
  </>);
};

export default withAdminAuth(BookingList);